import React, { useState, useEffect } from "react";
import { Box, makeStyles, Typography, Button } from "@material-ui/core";
import InputWithLabel from "../Inputs/InputWithLabel";
import CustomCheckbox from "../Inputs/CustomCheckbox";
import Label from "../Misc/Label";
import InputWithHorizontalLabel from "../Inputs/InputWithHorizontalLabel";
import { addCampaignDetails } from "../../redux/actions/uiActions";
import { useDispatch, useSelector } from "react-redux";
import { set } from "date-fns";

const useStyles = makeStyles((theme) => ({
  container: {
    // background: "#FFFFFF",
    // boxShadow: "4px 4px 30px rgba(34, 43, 69, 0.08)",
    // borderRadius: "8px",
    // padding: 24,
  },
  pageHeading: {
    fontWeight: "700",
    fontSize: "2.4rem",
    lineHeight: "3.2rem",
    marginBottom: 6,
  },

  headingDesc: {
    fontWeight: "400",
    fontSize: "1.4rem",
    lineHeight: "2.4rem",
    color: "rgba(0,0,0, 0.46)",
  },

  stepHeader: {
    marginBottom: "3rem",
  },
}));

const TokenPoolReqStepOne = ({
  changeFlag,
  onNextClick,
  setDisableButton,
  formErrors,
  setFormErrors,
}) => {
  const classes = useStyles();

  const [budget, setBudget] = useState();
  const [campaignName, setCampaignName] = useState("");

  const [totalFollowersRequired, setTotalFollowersRequired] = useState();
  const [allocationRatePerFollower, setAllocationRatePerFollower] = useState();
  const dispatch = useDispatch();

  const [platforms, setPlatforms] = useState({
    1: {
      name: "Twitter",
      followers: "",
      posts: "",
      key: 101,
    },
    2: {
      name: "Youtube",
      followers: "",
      posts: "",
      key: 111,
    },
    3: {
      name: "TikTok",
      followers: "",
      posts: "",
      key: 141,
    },
    4: {
      name: "Instagram",
      followers: "",
      posts: "",
      key: 113,
    },
  });
  const isUser = useSelector((state) => state.ui.isUser);

  let categoryArray;

  const [postDescription, setPostDescription] = useState("");
  console.log({ platforms });
  const [checkBoxes, setCheckBoxes] = useState({
    1: true,
    2: false,
    3: false,
    4: false,
  });

  useEffect(() => {
    if (campaignName && budget && postDescription) setDisableButton(false);
  }, [campaignName, budget, postDescription]);

  useEffect(() => {
    if (changeFlag === 1 && formErrors.postError === "") {
      console.log("flag clicked 1");

      const platformsModified = Object.keys(platforms).map(
        (v, i) => platforms[v]
      );

      console.log({ platformsModified });
      setPlatforms(platformsModified);
      dispatch(
        addCampaignDetails({
          campaignName,
          budget,
          platforms,
          totalFollowersRequired,
          allocationRatePerFollower,
          postDescription,
        })
      );

      onNextClick();
    }
    console.log("PLATFORMS::", platforms);
  }, [changeFlag]);

  useEffect(() => {
    if (totalFollowersRequired && budget) {
      setAllocationRatePerFollower(budget / totalFollowersRequired);
    } else {
      setAllocationRatePerFollower(0);
    }
  }, [budget, totalFollowersRequired]);

  return (
    <Box className={classes.container}>
      <Box className={classes.stepHeader}>
        <Typography className={classes.pageHeading}>Step 1</Typography>

        <Typography className={classes.headingDesc}>
          Give the details about your campaign
        </Typography>
      </Box>

      <Box>
        <InputWithLabel
          label="Campaign Name"
          value={campaignName}
          setValue={setCampaignName}
          placeholder="Campaign 01"
        />
        <InputWithLabel
          label="Budget (USDT)"
          value={budget}
          setValue={setBudget}
          placeholder="20,000"
          type="number"
          // maxValue1={Number(isUser?.project?.marketingBudget)}
        />

        <InputWithLabel
          label="Total Followers Required"
          value={totalFollowersRequired}
          setValue={setTotalFollowersRequired}
          placeholder="2,530,000"
          type="number"
        />
        <InputWithLabel
          label="Allocation Rate per Follower"
          value={allocationRatePerFollower}
          setValue={setAllocationRatePerFollower}
          placeholder="0.02"
          type="number"
        />

        <Box marginBottom="2.4rem">
          <Label label="platformss" />

          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <CustomCheckbox
              label="Twitter"
              checked={checkBoxes[1]}
              handleChange={() =>
                setCheckBoxes({
                  ...checkBoxes,
                  1: !checkBoxes[1],
                })
              }
            />
            <CustomCheckbox
              label="Youtube"
              disable
              checked={checkBoxes[2]}
              handleChange={() =>
                setCheckBoxes({
                  ...checkBoxes,
                  2: !checkBoxes[2],
                })
              }
            />
            <CustomCheckbox
              label="TikTok"
              disable
              checked={checkBoxes[3]}
              handleChange={() =>
                setCheckBoxes({
                  ...checkBoxes,
                  3: !checkBoxes[3],
                })
              }
            />
            <CustomCheckbox
              label="Instagram"
              disable
              checked={checkBoxes[4]}
              handleChange={() =>
                setCheckBoxes({
                  ...checkBoxes,
                  4: !checkBoxes[4],
                })
              }
            />
          </Box>
        </Box>

        <Box marginBottom="1.6rem">
          {checkBoxes[1] || checkBoxes[2] || checkBoxes[3] || checkBoxes[4] ? (
            <Label label="Followers per platforms (%)" />
          ) : null}

          <Box
            display="flex"
            alignItems="center"
            // justifyContent="space-between"
          >
            {checkBoxes[1] && (
              <InputWithHorizontalLabel
                placeholder="i.e: 30"
                width={80}
                rightText="%"
                marginRight={50}
                value={platforms[1].followers}
                setValue={(followers) =>
                  setPlatforms({
                    ...platforms,
                    1: { ...platforms[1], followers },
                  })
                }
              />
            )}
            {checkBoxes[2] && (
              <InputWithHorizontalLabel
                placeholder="i.e: 30"
                width={80}
                rightText="%"
                marginRight={50}
                value={platforms[2].followers}
                setValue={(followers) =>
                  setPlatforms({
                    ...platforms,
                    2: { ...platforms[2], followers },
                  })
                }
              />
            )}

            {checkBoxes[3] && (
              <InputWithHorizontalLabel
                placeholder="i.e: 30"
                width={80}
                rightText="%"
                marginRight={50}
                value={platforms[3].followers}
                setValue={(followers) =>
                  setPlatforms({
                    ...platforms,
                    3: { ...platforms[3], followers },
                  })
                }
              />
            )}

            {checkBoxes[4] && (
              <InputWithHorizontalLabel
                placeholder="i.e: 30"
                width={80}
                rightText="%"
                marginRight={50}
                value={platforms[4].followers}
                setValue={(followers) =>
                  setPlatforms({
                    ...platforms,
                    4: { ...platforms[4], followers },
                  })
                }
              />
            )}
          </Box>
        </Box>

        <Box marginBottom="1.6rem">
          {checkBoxes[1] || checkBoxes[2] || checkBoxes[3] || checkBoxes[4] ? (
            <Label label="Posts per platforms" />
          ) : null}

          <Box
            display="flex"

            // alignItems="center"
            // justifyContent="space-between"
          >
            {checkBoxes[1] && (
              <InputWithHorizontalLabel
                placeholder="i.e: 30"
                width={80}
                // rightText="%"
                marginRight={70}
                value={platforms[1].posts}
                setValue={(posts) =>
                  setPlatforms({ ...platforms, 1: { ...platforms[1], posts } })
                }
              />
            )}

            {checkBoxes[2] && (
              <InputWithHorizontalLabel
                placeholder="i.e: 30"
                width={80}
                // rightText="%"
                marginRight={70}
                value={platforms[2].posts}
                setValue={(posts) =>
                  setPlatforms({ ...platforms, 2: { ...platforms[2], posts } })
                }
              />
            )}

            {checkBoxes[3] && (
              <InputWithHorizontalLabel
                placeholder="i.e: 30"
                width={80}
                // rightText="%"
                marginRight={70}
                value={platforms[3].posts}
                setValue={(posts) =>
                  setPlatforms({ ...platforms, 3: { ...platforms[3], posts } })
                }
              />
            )}

            {checkBoxes[4] && (
              <InputWithHorizontalLabel
                placeholder="i.e: 30"
                width={80}
                // rightText="%"
                marginRight={70}
                value={platforms[4].posts}
                setValue={(posts) =>
                  setPlatforms({ ...platforms, 4: { ...platforms[4], posts } })
                }
              />
            )}
          </Box>
        </Box>
        <InputWithLabel
          label="Post Description"
          placeholder="Enter description here..."
          height={100}
          value={postDescription}
          setValue={setPostDescription}
          campaignPost
          setFormErrors={setFormErrors}
          error={formErrors.postError}
        />
      </Box>
    </Box>
  );
};

export default TokenPoolReqStepOne;
